import { render, staticRenderFns } from "./TheModalReserva.vue?vue&type=template&id=8c402ffa&"
import script from "./TheModalReserva.vue?vue&type=script&lang=js&"
export * from "./TheModalReserva.vue?vue&type=script&lang=js&"
import style0 from "./TheModalReserva.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports